<template>
    <v-alert :value="showWarning" color="info" icon="warning" outline>
        {{ $t('site.fellowship.notifications.limitedHistory',[objectType]) }}
    </v-alert>
</template>

<script>
    export default {
        name: "elv-check-back-when-more-info",
        props: {
            object: {required: true}
        },
        data() {
            return {
                objectType: "Player"
            };
        },
        computed: {
            computeDaysSinceCreated: {
                get: function () {
                    let createdDate = this.object.createdAt || this.object.createdDate;
                    let days = moment().diff(moment(createdDate), "days");
                    //console.log("days tracked: " + days);
                    return days;
                }
            },
            showWarning: {
                get: function() {
                    //console.log("days since tracked: " + this.computeDaysSinceCreated );
                    return this.computeDaysSinceCreated < 14;
                }
            }

        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ElvCheckBackWhenMoreInfo.vue